import React from 'react';
import 'CSS/demand-supply/demand-supply.scss';
import 'CSS/dashboard-statistic.scss';
import 'CSS/dashboard-tickets.scss';
import 'CSS/dashboard-slips.scss';
import Grid from '@material-ui/core/Grid';
import moment from 'moment-timezone';
import styled from 'styled-components';
import AvatarUser from '../AvatarUser';

const Msg = styled.div`
  max-width: 70%;
  margin-left: ${({ name, creatorName }) =>
    name !== creatorName ? 'auto' : '0'};
  margin-right: ${({ name, creatorName }) =>
    name !== creatorName ? '0' : 'auto'};
  align-items: flex-start;
  justify-content: ${({ name, creatorName }) =>
    name !== creatorName ? ' flex-end' : 'flex-start'};
  display: flex;
  margin-bottom: 6px;
`;

const MsgAndTime = styled.div`
  margin: ${({ name, creatorName }) =>
    name !== creatorName ? '0 5px 0 0' : '0 0 0 5px'};
`;

const Text = styled.div`
  padding: 5px;
  background-color: ${({ name, creatorName }) =>
    name !== creatorName ? '#ffca28' : '#bdbdbd'};
  text-align: ${({ name, creatorName }) =>
    name !== creatorName ? 'right' : 'left'};
  border-radius: 4px;
`;

const Time = styled.div`
  font-size: 14px;
  text-align: ${({ name, creatorName }) =>
    name !== creatorName ? 'right' : 'left'};
`;
const Chat = styled(Grid)`
  padding: 5px;
  border: 1px solid black;
  border-radius: 3px;
`;

var prevName = 'something';
var showAvatar = true;
const renderChat = note => {
  const twoMsg = '_#%_';
  const timeToName = '_#?_';
  const nameToMsg = '_#$_';
  let result = [];
  if (note) {
    let msgs = note.split(twoMsg);
    for (var i = 0; i < msgs.length; i++) {
      let el = msgs[i];
      let time = el.split(timeToName)[0];
      let rest = el.split(timeToName)[1];
      let name = rest.split(nameToMsg)[0];
      let text = rest.split(nameToMsg)[1];

      var timeToLocal = moment
        .utc(time)
        .local()
        .format("'" + 'YY-MMM-DD HH:mm');
      let msgObj = {
        time: timeToLocal,
        name: name,
        text: text,
      };
      result.push(msgObj);
    }
  }
  return result;
};

export const SupplyNote = props => {
  return (
    <Grid item xs={props.fullwidth ? 12 : 6}>
      <Grid container className="">
        {/* <h2 className="t-primary-16 t-weight-b u-mrg-bot-10 u-mrg-top-10">
          Supply note
        </h2> */}

        <h2 className="t-primary-16 t-weight-b u-mrg-bot-10 u-mrg-top-10">
          Correspondence
        </h2>
        {/* ovo ukljuci ako prodje logika sa konkatenacijom komentara i slipnota */}
        {/* border-bottom-light-gray-2  */}
        <Grid
          container
          className="t-primary-14 c-gray-light supply-note  u-pad-bot-10"
        >
          <Chat item xs={12} className="">
            {renderChat(props.note).map((el, index) => {
              if (index === 0) {
                prevName = 'showFirstElBug';
              }
              if (prevName !== el.name) {
                showAvatar = true;
                prevName = el.name;
              } else {
                showAvatar = false;
              }
              prevName = el.name;
              return (
                <Msg name={el.name} creatorName={props.user} key={index}>
                  {el.name === props.user ? (
                    <AvatarUser showAvatar={showAvatar} user={el.name} />
                  ) : null}
                  <MsgAndTime
                    name={el.name}
                    creatorName={props.user}
                    index={index}
                  >
                    <Text name={el.name} creatorName={props.user}>
                      {el.text.includes('%20') ? decodeURI(el.text) : el.text}
                    </Text>
                    <Time name={el.name} creatorName={props.user}>
                      {el.time}
                    </Time>
                  </MsgAndTime>
                  {el.name !== props.user ? (
                    <AvatarUser showAvatar={showAvatar} user={el.name} />
                  ) : null}
                </Msg>
              );
            })}
          </Chat>
        </Grid>
      </Grid>
    </Grid>
  );
};
